import { createContext, type ReactNode, useContext, useState } from 'react';

import CliLoginDialog from '@cloud-ui/components/shared/cli-auth/CliLoginDialog';

interface CliLoginDialogContextType {
  openCliLoginDialog: () => void;
  closeCliLoginDialog: () => void;
}

const CliLoginDialogContext = createContext<CliLoginDialogContextType | undefined>(undefined);

export const CliLoginDialogProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openCliLoginDialog = () => {
    setIsOpen(true);
  };

  const closeCliLoginDialog = () => {
    setIsOpen(false);
  };

  return (
    <CliLoginDialogContext.Provider value={{ openCliLoginDialog, closeCliLoginDialog }}>
      {children}
      <CliLoginDialog open={isOpen} onClose={closeCliLoginDialog} />
    </CliLoginDialogContext.Provider>
  );
};

export const useCliLoginDialog = () => {
  const context = useContext(CliLoginDialogContext);
  if (!context) {
    throw new Error('useCliLoginDialog must be used within a CliLoginDialogProvider');
  }
  return context;
};
